<template>
  <div class="container flex" style="padding-bottom: 20px;">
    <div>
      <left></left>
	   <input type="file" multiple name="fileImage[]" class="el-upload__input" @change="getpic()" ref="file" style="display: none;" accept=".png,.jpg">
    </div>
    <div class="newsdetail flex1" style="margin-left: 20px;">
    			<div class="flex title">
    				<span>学习指导</span>
    				<span style="color: #4fa7ff;cursor: pointer;" @click="handleBack">返回</span>
    			</div>
    			<div class="content margin-t-15">
    				<div class="fontweight" style="font-size: 18px;text-align: center;font-weight: bold;">
    					{{data.newsTitle}}
    				</div>
    				<div class="text-center" style="display: flex;align-items: center;justify-content: center;margin-top: 15px;">
    					<img src="../assets/img/time.png" >
    					<span class="text-gray margin-l-10">{{data&&data.newsUpdateTime.slice(0,10)}}</span>
    					<img style="margin-left: 20px;" src="../assets/img/viewcount.png" >
    					<span class="text-gray margin-l-10">{{data.newsViews}}人浏览</span>
    				</div>
    				<div class="line">

    				</div>
    				<div class="des" v-html="data.newsContent">

    				</div>
    				<div class="line">

    				</div>
    				<div class="" style="padding: 0 30px;">
    					<textarea rows="" cols="" placeholder="说点儿什么....." v-model="commentContent"></textarea>
    				</div>
					<div  style="padding: 0 30px;margin-top: 30px;">
						<div class="font14">
							请提供问题的截图或照片（选填）
						</div>
						<div class="imglist flex">
								<div class="imgwrap" v-for="item,index in cover">
									<img :src="item" class="pic" >
									<img src="../assets/img/delpic.png" class="delpic" @click="handleDelete(index)" >
								</div>
								<div class="imgwrap" style="cursor: pointer;" @click="uploadimg()">
									<img src="../assets/img/addpic.png" >
								</div>
						</div>
					</div>
    				<div class="text-right" style="padding: 0 30px;">
    					<span class="btn" style="cursor: pointer;" @click="handleSubmitComment">发送</span>
    				</div>
    				<div class="line">

    				</div>
    				<div class="commentlist" style="padding: 0 30px;">
    					<div class="flex algin-center" style="margin-bottom: 30px;">
    						<span>全部评论</span>
    						<span class="font14 text-gray margin-l-10">{{total}}</span>
    					</div>
    					<template v-for="item in commentList">
    					  <div class="list">
    					  	<img :src="item.headPortrait" class="avator" >
    					  	<div class="right">
    					  		<div class="nickname">
    					  			{{item.nickName}}
    					  		</div>
    					  		<div class="font14 text-gray margin-t-5">
    					  			{{item.commentContent}}
    					  		</div>
								<div class="imglist" v-if="item.picArr.length>0">
															<img :src="voo" class="pic" v-for="voo,index in item.picArr"
																@click="openPic(item.picArr,index)">
														</div>
    					  		<div class="datetime">
    					  			{{item.commentTime}}
    					  		</div>
    					  	</div>
    					  </div>
    					  <div class="line">

    					  </div>
    					</template>


    				</div>
    			</div>
    		</div>
  </div>
</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:'',
          newsId:null,
          commentContent:'',
          commentList:[],
          total:0,
		  cover:[],
      }
    },
    methods:{
		handleDelete(index){
		  this.cover.splice(index,1)
		},
		uploadimg:function(){
		
		    document.querySelector('.el-upload__input').click();
		},
      handleBack(){
        this.$router.go(-1)
      },
	  getpic:function(){
	  
	          var el=document.querySelector('.el-upload__input');
	          this.upload(el.files)
	  //    console.log(URL.createObjectURL(el.files[0]))
	  //    this.head=URL.createObjectURL(el.files[0]);
	  },
	  upload(files){
	        for(let i=0;i<files.length;i++){
	          let data=new FormData();
	              data.append('file',files[i]);
	          this.$axios.post(this.$common.upload_url,data).then((res)=>{
	                if(res.data.status=='success'){
	                     this.cover.push(res.data.message)
	                }
	                else {
	                  alert(res.data.msg)
	                }
	          })
	        }
	  },
      getData(){
        this.$axios.get(this.$common.new_detail+'?newId='+this.newsId).then((res)=>{
              if(res.data.code==1){
                this.data=res.data.data;
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      getCommentList(){
        this.$axios.get(this.$common.comments_list+'?newId='+this.newsId).then((res)=>{
              if(res.data.code==1){
                  this.commentList=res.data.data.list;
                  this.total=res.data.data.total;
            //    this.data=res.data.data;
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleSubmitComment(){
        if(!window.sessionStorage.token){

          alert('请选登录');
          return;
        }
        if(this.commentContent==''){

          alert('请输入评论内容');
          return;
        }
        let data=new FormData();
            data.append('newsId',this.newsId);
            data.append('commentContent',this.commentContent);
			data.append('pics',this.cover.join());
        this.$axios.post(this.$common.comments_comments,data).then((res)=>{
              if(res.data.code==1){
                  this.commentContent='';
                  this.getCommentList()
                  alert(res.data.msg)
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created(){
      this.newsId=this.$route.query.newsId;
      this.getData();
      this.getCommentList();
    }
  }
</script>

<style scoped>
  .newsdetail {
    border: 1px solid silver;
  }
  .newsdetail .title {
  	justify-content: space-between;
  	background-color: #eeeeee;
  	padding: 15px;

  }
  .line {
  	height: 1px;
  	background-color: #eee;
  	margin: 30px 30px;

  }
  .des {
  	padding: 0 30px;
  }
  textarea {
  	width: 100%;
  	height: 112px;
  	font-size: 14px;
  	background-color: #f4f4f4;
  	border: 1px solid #ccc;
  	text-indent: 15px;
  	padding: 15px 0;
  	outline: none;
  }
  .btn {
  	width: 100px;
  	height: 40px;
  	text-align: center;
  	display: inline-block;
  	background-color: #fff;
  	line-height: 40px;
  	font-size: 14px;
  	background-color: #4fa7ff;
  	color: #fff;
  	border-radius: 4px;
  	margin-top: 15px;
  }
  .commentlist .list {
  	display: flex;
  }
  .commentlist .line {
  	margin: 30px 0;
  }
  .avator {
  	width: 50px;
  	height: 50px;
  	border-radius: 50%;
  	margin-right: 10px;
  }
  .datetime {
  	font-size: 14px;
  	color: #aaaaaa;
  	margin-top: 5px;
  }
  .imglist {
  	margin-top: 15px;
  }
  .imgwrap{
  	margin-right: 15px;
  	position: relative;
  }
  .delpic {
  	position: absolute;
  	right: 2px;
  	top: 2px;
  }
  .imglist .pic {
  		width: 100px;
  		height: 100px;
  		object-fit: cover;
  		margin-right: 10px;
  		
  	}
</style>



// WEBPACK FOOTER //
// src/components/newsdetail.vue